<template>
  <div id="user-edit-tab-info">
    <div id="teacherDataUpdateLoadingDiv" class="vs-con-loading__container">
      <!-- Avatar Row -->
      <form>
        <!-- <div class="vx-row mt-2">
          <div class="vx-col sm:w-full w-full mb-5">
            <vx-input-group class="mb-2">
              <template slot="prepend">
                <div class="prepend-text pl-0" style="background-color: #e7e7e7;">
                  <vs-input style="color: grey;" readonly  value="Opsamlingssteder" />
                </div>
              </template>
              <vs-input v-validate="''" name="opsamlingssteder" ref="opsamlingssteder" v-model="opsamlingssteder" />
            </vx-input-group>
            <span class="text-danger text-sm" v-show="errors.has('opsamlingssteder')">This field is required</span>
          </div>
        </div>

        <div class="vx-row mt-2">
          <div class="vx-col sm:w-full w-full mb-5">
            <vx-input-group class="mb-2">
              <template slot="prepend">
                <div class="prepend-text pl-0" style="background-color: #e7e7e7;">
                  <vs-input style="color: grey;" readonly  value="Beskrivelse" />
                </div>
              </template>
              <vs-input v-validate="''" name="beskrivelse" ref="beskrivelse" v-model="beskrivelse" />
            </vx-input-group>
            <span class="text-danger text-sm" v-show="errors.has('beskrivelse')">This field is required</span>
          </div>
        </div>

        <div class="vx-row mt-2">
          <div class="vx-col sm:w-full w-full mb-5">
            <vx-input-group class="mb-2">
              <template slot="prepend">
                <div class="prepend-text pl-0" style="background-color: #e7e7e7;">
                  <vs-input style="color: grey;" readonly  value="Sprog" />
                </div>
              </template>
              <vs-input v-validate="''" name="sprog" ref="sprog" v-model="sprog" />
            </vx-input-group>
            <span class="text-danger text-sm" v-show="errors.has('sprog')">This field is required</span>
          </div>
        </div>

        <div class="vx-row mt-2">
          <div class="vx-col sm:w-full w-full mb-5">
            <vx-input-group class="mb-2">
              <template slot="prepend">
                <div class="prepend-text pl-0" style="background-color: #e7e7e7;">
                  <vs-input style="color: grey;" readonly  value="Uddannet" />
                </div>
              </template>
              <vs-input v-validate="''" name="uddannet" ref="uddannet" v-model="uddannet" />
            </vx-input-group>
            <span class="text-danger text-sm" v-show="errors.has('uddannet')">This field is required</span>
          </div>
        </div>

        <div class="vx-row mt-2">
          <div class="vx-col sm:w-full w-full mb-5">
            <vx-input-group class="mb-2">
              <template slot="prepend">
                <div class="prepend-text pl-0" style="background-color: #e7e7e7;">
                  <vs-input style="color: grey;" readonly  value="Ekstra lektionspris" />
                </div>
              </template>
              <vs-input v-validate="''" name="eekstralektionspris" ref="eekstralektionspris" v-model="eekstralektionspris" />
            </vx-input-group>
            <span class="text-danger text-sm" v-show="errors.has('eekstralektionspris')">This field is required</span>
          </div>
        </div>

        <div class="vx-row mt-2">
          <div class="vx-col sm:w-full w-full mb-5">
            <vx-input-group class="mb-2">
              <template slot="prepend">
                <div class="prepend-text pl-0" style="background-color: #e7e7e7;">
                  <vs-input style="color: grey;" readonly  value="Aftentillæg" />
                </div>
              </template>
              <vs-input v-validate="''" name="aftentillæg" ref="aftentillæg" v-model="aftentillæg" />
            </vx-input-group>
            <span class="text-danger text-sm" v-show="errors.has('aftentillæg')">This field is required</span>
          </div>
        </div>

        <div class="vx-row mt-2">
          <div class="vx-col sm:w-full w-full mb-5">
            <vx-input-group class="mb-2">
              <template slot="prepend">
                <div class="prepend-text pl-0" style="background-color: #e7e7e7;">
                  <vs-input style="color: grey;" readonly  value="Weekendstillæg" />
                </div>
              </template>
              <vs-input v-validate="''" name="weekendstillæg" ref="weekendstillæg" v-model="weekendstillæg" />
            </vx-input-group>
            <span class="text-danger text-sm" v-show="errors.has('weekendstillæg')">This field is required</span>
          </div>
        </div>

        <vs-divider class="mb-base"/> -->

        <div class="vx-row  mb-base">
          <div class="vx-col md:w-full w-full">
            <vs-input class="w-full" v-validate="'max:500'" label="About me" v-model="aboutMe" name="aboutMe" />
            <span class="text-danger text-sm" v-show="errors.has('aboutMe')">{{ errors.first('aboutMe') }}</span>
          </div>
        </div>

        <div class="vx-row mt-base mb-base">
          <div class="vx-col md:w-full w-full">
            <vs-input class="w-full" v-validate="'max:500'" label="Opsamlingssteder" v-model="collectionPoint" name="collectionPoint" />
            <span class="text-danger text-sm" v-show="errors.has('collectionPoint')">{{ errors.first('collectionPoint') }}</span>
          </div>
        </div>

        <vs-divider class="mb-base"/>

        <div class="flex flex-wrap items-center justify-end vx-row mb-base">
          <div class="vx-col sm:w-full w-full flex flex-wrap items-center justify-end">
            <vs-button @click="addNewField()" class="ml-4" >Add field</vs-button>
          </div>
        </div>

        <div v-if="data_local.additional_detail && data_local.additional_detail.about_data">
          <div class="vx-row mt-2" v-for="(additionalDetail, index) in data_local.additional_detail.about_data" :key="index" >
            <div class="vx-col sm:w-full w-full mb-2">
              <vx-input-group class="mb-2">
                <template slot="prepend">
                  <div class="prepend-text pl-0" style="background-color: #e7e7e7;">
                    <vs-input style="color: grey;" v-validate="'required|max:100'" :name="'additional_detail_key_'+index" :ref="'additional_detail_key_'+index" v-model="additionalDetail.key" />
                  </div>
                </template>

                <vs-input v-validate="'required|max:500'" :name="'additional_detail_value_'+index" :ref="'additional_detail_value_'+index" v-model="additionalDetail.value" />

                <template slot="append">
                  <div class="append-text btn-addon" style="background-color: #e7e7e7;">
                    <vs-button @click="removeField(index)" class="" color="danger" type="filled" icon-pack="feather" icon="icon-x"></vs-button>
                  </div>
                </template>
              </vx-input-group>
              <span class="text-danger text-sm" v-show="errors.has('additional_detail_key_'+index)">{{ errors.first('additional_detail_key_'+index) }}</span>
              <span class="text-danger text-sm" v-show="errors.has('additional_detail_value_'+index)">{{ errors.first('additional_detail_value_'+index) }}</span>
            </div>
          </div>
        </div>

        

        <vs-divider class="mb-base"/>

        <div class="vx-row mb-base">
          <div class="vx-col md:w-1/2 w-full">
            <img src="@/assets/images/app/manual-tran.png" class="mr-8 rounded h-24" />
            <label>Manual Tran</label>
            <vs-switch v-model="manualTran">
            </vs-switch>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <img src="@/assets/images/app/automatic-tran.png" class="mr-8 rounded h-24" />
            <label>Automatic Tran</label>
            <vs-switch v-model="automaticTran">
            </vs-switch>
          </div>
        </div>

        <vs-divider class="mb-base"/>

        <div class="vx-row mt-base mb-base">
          <div class="vx-col md:w-full w-full">
            <vs-input class="w-full" v-validate="'url'" label="Youtube Video Url" v-model="videoUrl" name="videoUrl" />
            <span class="text-danger text-sm" v-show="errors.has('videoUrl')">{{ errors.first('videoUrl') }}</span>
          </div>
        </div>

        <vs-divider class="mb-base"/>

        <div class="flex flex-wrap items-center justify-end vx-row mt-2">
          <div class="vx-col sm:w-full w-full flex flex-wrap items-center justify-end">
            <vs-button @click="validateData()" class="ml-4 mt-2">Save Changes</vs-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import VueDawa from '@ancaio/vue-dawa/sfc'

export default {
  components: {
    vSelect,
    VueDawa
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      opsamlingssteder : "",
      beskrivelse : "",
      sprog : "",
      uddannet : "",
      eekstralektionspris : "",
      aftentillæg : "",
      weekendstillæg : "",
      videoUrl : "",
      aboutMe : "",
      collectionPoint : "",
      manualTran : false,
      automaticTran : false,
      data_local: JSON.parse(JSON.stringify(this.data)),
      
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any()
    }
  },
  mounted() {
    this.manualTran = this.data_local.additional_detail && this.data_local.additional_detail.more_data.manual_tran ? true : false;
    this.automaticTran = this.data_local.additional_detail && this.data_local.additional_detail.more_data.automatic_tran ? true : false;
    this.collectionPoint = this.data_local.additional_detail && this.data_local.additional_detail.more_data.collection_point ? this.data_local.additional_detail.more_data.collection_point : null;

    this.aboutMe = this.data_local.additional_detail && this.data_local.additional_detail.more_data.about_me ? this.data_local.additional_detail.more_data.about_me : null;
    this.videoUrl = this.data_local.additional_detail && this.data_local.additional_detail.video_url.length ? this.data_local.additional_detail.video_url[0] : null;
  },
  methods: {  
    validateData() {
      this.$validator.validateAll().then(result => {
        if (result) this.update_user()
      })
    },
    addNewField() {
      if(this.data_local.additional_detail){
        if(this.data_local.additional_detail && this.data_local.additional_detail.about_data){
          this.data_local.additional_detail.about_data.push({ key : "", value : ""})
        }
        else this.data_local.additional_detail.about_data = [{ key : "", value : ""}]
      }
      else this.data_local.additional_detail = {
        about_data : [{ key : "", value : ""}]
      }
      
    },
    removeField(index) {
      this.data_local.additional_detail.about_data.splice(index, 1);
    },
    update_user() {
      var self = this
      
      this.$vs.loading({
        container: '#teacherDataUpdateLoadingDiv',
        scale: 0.6
      })

      if(this.opsamlingssteder != "") this.data_local.additional_detail.about_data.push({ key : "opsamlingssteder", value : this.opsamlingssteder})
      if(this.beskrivelse != "") this.data_local.additional_detail.about_data.push({ key : "beskrivelse", value : this.beskrivelse})
      if(this.sprog != "") this.data_local.additional_detail.about_data.push({ key : "sprog", value : this.sprog})
      if(this.uddannet != "") this.data_local.additional_detail.about_data.push({ key : "uddannet", value : this.uddannet})
      if(this.eekstralektionspris != "") this.data_local.additional_detail.about_data.push({ key : "eekstralektionspris", value : this.eekstralektionspris})
      if(this.aftentillæg != "") this.data_local.additional_detail.about_data.push({ key : "aftentillæg", value : this.aftentillæg})
      if(this.weekendstillæg != "") this.data_local.additional_detail.about_data.push({ key : "weekendstillæg", value : this.weekendstillæg})

      if(this.videoUrl != "" && this.videoUrl != null) this.data_local.additional_detail.video_url = [this.videoUrl]

      if(this.data_local.additional_detail){
        this.data_local.additional_detail.more_data = {
          manual_tran : this.manualTran,
          automatic_tran : this.automaticTran,
          collection_point : this.collectionPoint ? this.collectionPoint : null,
          about_me : this.aboutMe ? this.aboutMe : null,
        }
      }
      else{
        this.data_local.additional_detail = {
          more_data : {
            manual_tran : this.manualTran,
            automatic_tran : this.automaticTran,
            collection_point : this.collectionPoint ? this.collectionPoint : null,
            about_me : this.aboutMe ? this.aboutMe : null,
          }
        }
      }
      

      let data = this.data_local;
      data.cover_image = null;
      data.image = null;

      var newData = {
        id : this.data_local.id,
        formData : data
      }
      this.$store.dispatch("userManagement/updateTeacher", newData)
        .then(res => { 
          this.$vs.loading.close('#teacherDataUpdateLoadingDiv > .con-vs-loading')

          this.$vs.notify({
            title: "Success.",
            text: "Teacher updated successfully.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success"
          });
        })
        .catch(err => { 
          this.$vs.loading.close('#teacherDataUpdateLoadingDiv > .con-vs-loading')

          if(err.status && err.status == 422){
            Object.keys(err.data).forEach(function(key) {
              self.errors.add({
                field: key,
                msg: err.data[key][0],
              });
            });
          }
        })
    },
    reset_data() {
      this.data_local = JSON.parse(JSON.stringify(this.data))
    },
  },
}
</script>
